import palette from './palette';

const input = {
  MuiInputBase: {
    styleOverrides: {
      input: {
        '::placeholder': {
          color: palette.grey[550],
          opacity: 1,
        },
      },
      multiline: {
        padding: '60px',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        position: 'relative',
        transform: 'none',
        transition: 'none',
        fontSize: '11px',
        fontWeight: 500,
        marginBottom: '4px',
        color: palette.common.black,
        lineHeight: '130%',
        '&.Mui-focused': {
          color: palette.common.black,
        },
        '&.Mui-error': {
          color: palette.red[200],
        },
        '&.Mui-disabled': {
          color: palette.common.black,
        },
        maxWidth: 'calc(100% - 15px)',
      },
      shrink: {
        transform: 'none',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: '2px',
        color: palette.common.black,
        background: palette.common.white,
        fontSize: '10px',
        fontWeight: 400,
        '&.MuiInputBase-multiline': {
          padding: '4px 0',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid',
          borderColor: palette.grey[200],
          borderRadius: '2px',
          top: '0px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
        },
        '&.Mui-disabled': {
          WebkitTextFillColor: palette.inputs.disabledText,
          '.Mui-disabled': {
            opacity: 1,
            WebkitTextFillColor: palette.inputs.disabledText,
          },
          '.MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
          },
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid',
          borderColor: palette.common.black,
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        },
        '&.MuiPickersOutlinedInput-notchedOutline legend': {
          width: 0,
        },
      },
      input: {
        padding: '8px 10px',
      },
      notchedOutline: {
        borderWidth: '1px',
        legend: {
          display: 'none',
        },
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      InputLabelProps: { shrink: true },
    },
    variants: [
      {
        props: { size: 'sm' },
        style: {
          '& .MuiInputBase-root': {
            fontSize: '0.875rem',
            padding: '8px 12px',
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem',
          },
        },
      },
      {
        props: { size: 'md' },
        style: {
          '& .MuiInputBase-root': {
            fontSize: '0.975rem',
            padding: '16px 8px 1px 8px',
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.675rem',
          },
        },
      },
    ],
  },
};
export default input;
